import { render } from "./LinedTextarea.vue?vue&type=template&id=ba7dfe44&scoped=true"
import script from "./LinedTextarea.vue?vue&type=script&lang=js"
export * from "./LinedTextarea.vue?vue&type=script&lang=js"

import "./LinedTextarea.vue?vue&type=style&index=0&id=ba7dfe44&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ba7dfe44"

export default script